import { type AnyElement, toCamel } from "@zyzgroup/core-common";

export function dataset(el: AnyElement): Record<string, any>; // read all
export function dataset(el: AnyElement, key: string): string; // read single
export function dataset(el: AnyElement, key: string, value: string): void; // write single
export function dataset(el: AnyElement, key: Record<string, any>): void; // write all
export function dataset(
  el: AnyElement,
  key?: string | Record<string, any>,
  value?: string
) {
  if (typeof key === "string") {
    key = toCamel(key);
  }
  if ((typeof key === "string" || key === undefined) && value === undefined) {
    // read
    const data = Object.assign({}, el.dataset);
    Object.keys(data).forEach((key) => {
      if (data[key]?.startsWith("[") || data[key]?.startsWith("{")) {
        try {
          data[key] = JSON.parse(data[key] || "");
        } catch (e) {
          //
        }
      }
    });
    return typeof key === "string" ? data[key] : data;
  } else {
    // write
    let obj: Record<string, any> = {};
    if (typeof key == "object") {
      obj = key;
    } else if (typeof key == "string") {
      obj[key] = value;
    }
    Object.entries(obj).forEach(([name, val]) => {
      if (val) {
        el.dataset[name] = val instanceof Object ? JSON.stringify(val) : val;
      } else {
        delete el.dataset[name];
      }
    });
  }
}

export function atomRemoveDataset(el: AnyElement, key: string) {
  key.split(/[,\s]+/).forEach((k) => {
    if (k.trim() != "") {
      delete el.dataset[k.trim()];
    }
  });
}
